import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import MinutesToText from 'modules/attendance/components/MinutesToText'

interface Props {
  title: string
  value: number
}

const CategoryWithValue = ({ title, value }: Props) => (
  <Box flexDirection="row" justifyContent="spaceBetween" width="full">
    <Text size="300" weight="medium" color="grey1000">
      {title}
    </Text>
    <MinutesToText color="grey1000" value={value} size="300" weight="medium" />
  </Box>
)

export default CategoryWithValue
